import { get, post, del, patch } from './base';

// /community/recent-posts/
const URL = '/community';

export const GetRecentPostAPI = (config, count = 10) =>
  get(`${URL}/recent-posts/?count=${count}`, config);
export const GetPostDetailAPI = (id, config) =>
  get(`${URL}/posts/${id}/`, config);
export const GetPostCommentsAPI = (id, config) =>
  get(`${URL}/posts/${id}/comments/`, config);
export const GetEventDetailAPI = (id, config) =>
  get(`${URL}/events/${id}/`, config);
export const GetEventCommentsAPI = (id, config) =>
  get(`${URL}/events/${id}/comments/`, config);
export const GetEventsAPI = (config, page_size) =>
  get(`${URL}/events/?page_size=${page_size}`, config);
export const GetNoticeFixed = () => get(`${URL}/notices-fixed/`);
export const GetNoticeDetailAPI = (id, config) =>
  get(`${URL}/notices/${id}/`, config);
export const GetNoticeCommentsAPI = (id, config) =>
  get(`${URL}/notices/${id}/comments/`, config);
export const GetNoticesAPI = (config, page_size) =>
  get(`${URL}/notices/?page_size=${page_size}`, config);

export const PostCommunityPost = (PostingPost, config) =>
  post(`${URL}/posts/`, PostingPost, config);
export const DeleteCommunityPost = (feedId, config) =>
  del(`${URL}/posts/${feedId}/`, config);
export const PatchCommunityPost = (feedId, PostingPost, config) =>
  patch(`${URL}/posts/${feedId}/`, PostingPost, config);
export const PostCommunityImage = (image, config) =>
  post('/community/posts-image/', image, config);

export const GetCommunityUserAPI = (id, config) =>
  get(`${URL}/users/${id}/`, config);

// Branches
export const GetAllBranchesNewsAPI = count =>
  get(`${URL}/branch-news/?count=${count}`);
export const GetBranchNewsAPI = (id, count) =>
  get(`${URL}/branch-news/?region=${id}&count=${count}`);
export const GetEventFeedAPI = id => get(`${URL}/events/${id}/`);
export const GetPostFeedAPI = id => get(`${URL}/posts/${id}/`);

// user
export const GetFeedByUserAPI = (id, size, config) =>
  get(
    `${URL}/post-list-by-a-user/?user=${id}&page=1&page_size=${size}`,
    config,
  );

// likes
export const PostFeedLikeAPI = (id, config) =>
  post(`${URL}/posts/${id}/likes/`, {}, config);
export const PostEventLikeAPI = (id, config) =>
  post(`${URL}/events/${id}/likes/`, {}, config);
export const PostNoticeLikeAPI = (id, config) =>
  post(`${URL}/notices/${id}/likes/`, {}, config);

// comments
export const PostFeedCommentAPI = (id, payload, config) =>
  post(`${URL}/posts/${id}/comments/`, payload, config);
export const PostEventCommentAPI = (id, payload, config) =>
  post(`${URL}/events/${id}/comments/`, payload, config);
export const PostNoticeCommentAPI = (id, payload, config) =>
  post(`${URL}/notices/${id}/comments/`, payload, config);

export const DeleteFeedCommentAPI = (id, config) =>
  del(`${URL}/posts/comment/${id}/`, config);
export const DeleteEventCommentAPI = (id, config) =>
  del(`${URL}/events/comment/${id}/`, config);
export const DeleteNoticeCommentAPI = (id, config) =>
  del(`${URL}/notices/comment/${id}/`, config);

// report, block
export const PostReportPost = (payload, config) =>
  post(`${URL}/report-post/`, payload, config);
export const PostReportComment = (payload, config) =>
  post(`${URL}/report-comment/`, payload, config);
export const PostBlockUser = (userId, config) =>
  post(`${URL}/block-user/`, { target_user: userId }, config);
export const PostUserReport = (userId, config) =>
  post(`${URL}/report-user/`, { reported_user: userId }, config);

export const GetStitchLetterAPI = () => get(`${URL}/letter/`);
